module.exports = __webpack_public_path__ + "static/media/Oxygen-Bold.40eb9fcf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OxygenBold/Oxygen-Bold.woff
// module id = 2944
// module chunks = 0